module.exports = __webpack_public_path__ + "static/media/br.e7cd4702.PNG";